module.exports = __webpack_public_path__ + "images/jumpstart-sticky-banner-bg-1920.jpg";